/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProfileHealthProfileIdRouteImport } from './routes/profile/$healthProfileId'
import { Route as AppSplatRouteImport } from './routes/app/$'
import { Route as AuthenticatedDebugSentryRouteImport } from './routes/_authenticated/debug-sentry'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authNewPasswordRouteImport } from './routes/(auth)/new-password'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authEmailVerificationRouteImport } from './routes/(auth)/email-verification'
import { Route as AuthenticatedSellersIndexRouteImport } from './routes/_authenticated/sellers/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedNewsIndexRouteImport } from './routes/_authenticated/news/index'
import { Route as AuthenticatedHelmetsIndexRouteImport } from './routes/_authenticated/helmets/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedArticlesIndexRouteImport } from './routes/_authenticated/articles/index'
import { Route as AuthenticatedAppUsersIndexRouteImport } from './routes/_authenticated/app-users/index'
import { Route as AuthenticatedAppUserHelmetsIndexRouteImport } from './routes/_authenticated/app-user-helmets/index'
import { Route as AuthenticatedSellersNewRouteImport } from './routes/_authenticated/sellers/new'
import { Route as AuthenticatedNotificationsNewRouteImport } from './routes/_authenticated/notifications/new'
import { Route as AuthenticatedNewsNewRouteImport } from './routes/_authenticated/news/new'
import { Route as AuthenticatedHelmetsNewRouteImport } from './routes/_authenticated/helmets/new'
import { Route as AuthenticatedArticlesNewRouteImport } from './routes/_authenticated/articles/new'
import { Route as AuthenticatedAppUserHelmetsNewRouteImport } from './routes/_authenticated/app-user-helmets/new'
import { Route as AuthenticatedSellersSellerIdIndexRouteImport } from './routes/_authenticated/sellers/$sellerId/index'
import { Route as AuthenticatedNewsNewsIdIndexRouteImport } from './routes/_authenticated/news/$newsId/index'
import { Route as AuthenticatedHelmetsHelmetIdIndexRouteImport } from './routes/_authenticated/helmets/$helmetId/index'
import { Route as AuthenticatedArticlesArticleIdIndexRouteImport } from './routes/_authenticated/articles/$articleId/index'
import { Route as AuthenticatedAppUsersAppUserIdIndexRouteImport } from './routes/_authenticated/app-users/$appUserId/index'
import { Route as AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRouteImport } from './routes/_authenticated/app-user-helmets/$appUserHelmetId/index'
import { Route as AuthenticatedSellersSellerIdEditRouteImport } from './routes/_authenticated/sellers/$sellerId/edit'
import { Route as AuthenticatedNewsNewsIdEditRouteImport } from './routes/_authenticated/news/$newsId/edit'
import { Route as AuthenticatedHelmetsHelmetIdEditRouteImport } from './routes/_authenticated/helmets/$helmetId/edit'
import { Route as AuthenticatedArticlesArticleIdEditRouteImport } from './routes/_authenticated/articles/$articleId/edit'
import { Route as AuthenticatedAppUsersAppUserIdEditRouteImport } from './routes/_authenticated/app-users/$appUserId/edit'
import { Route as AuthenticatedAppUserHelmetsAppUserHelmetIdEditRouteImport } from './routes/_authenticated/app-user-helmets/$appUserHelmetId/edit'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileHealthProfileIdRoute = ProfileHealthProfileIdRouteImport.update({
  id: '/profile/$healthProfileId',
  path: '/profile/$healthProfileId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/app/$',
  path: '/app/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDebugSentryRoute =
  AuthenticatedDebugSentryRouteImport.update({
    id: '/debug-sentry',
    path: '/debug-sentry',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authNewPasswordRoute = authNewPasswordRouteImport.update({
  id: '/(auth)/new-password',
  path: '/new-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authEmailVerificationRoute = authEmailVerificationRouteImport.update({
  id: '/(auth)/email-verification',
  path: '/email-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSellersIndexRoute =
  AuthenticatedSellersIndexRouteImport.update({
    id: '/sellers/',
    path: '/sellers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNewsIndexRoute = AuthenticatedNewsIndexRouteImport.update({
  id: '/news/',
  path: '/news/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHelmetsIndexRoute =
  AuthenticatedHelmetsIndexRouteImport.update({
    id: '/helmets/',
    path: '/helmets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArticlesIndexRoute =
  AuthenticatedArticlesIndexRouteImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUsersIndexRoute =
  AuthenticatedAppUsersIndexRouteImport.update({
    id: '/app-users/',
    path: '/app-users/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUserHelmetsIndexRoute =
  AuthenticatedAppUserHelmetsIndexRouteImport.update({
    id: '/app-user-helmets/',
    path: '/app-user-helmets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSellersNewRoute = AuthenticatedSellersNewRouteImport.update({
  id: '/sellers/new',
  path: '/sellers/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsNewRoute =
  AuthenticatedNotificationsNewRouteImport.update({
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNewsNewRoute = AuthenticatedNewsNewRouteImport.update({
  id: '/news/new',
  path: '/news/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHelmetsNewRoute = AuthenticatedHelmetsNewRouteImport.update({
  id: '/helmets/new',
  path: '/helmets/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedArticlesNewRoute =
  AuthenticatedArticlesNewRouteImport.update({
    id: '/articles/new',
    path: '/articles/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUserHelmetsNewRoute =
  AuthenticatedAppUserHelmetsNewRouteImport.update({
    id: '/app-user-helmets/new',
    path: '/app-user-helmets/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSellersSellerIdIndexRoute =
  AuthenticatedSellersSellerIdIndexRouteImport.update({
    id: '/sellers/$sellerId/',
    path: '/sellers/$sellerId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNewsNewsIdIndexRoute =
  AuthenticatedNewsNewsIdIndexRouteImport.update({
    id: '/news/$newsId/',
    path: '/news/$newsId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHelmetsHelmetIdIndexRoute =
  AuthenticatedHelmetsHelmetIdIndexRouteImport.update({
    id: '/helmets/$helmetId/',
    path: '/helmets/$helmetId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArticlesArticleIdIndexRoute =
  AuthenticatedArticlesArticleIdIndexRouteImport.update({
    id: '/articles/$articleId/',
    path: '/articles/$articleId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUsersAppUserIdIndexRoute =
  AuthenticatedAppUsersAppUserIdIndexRouteImport.update({
    id: '/app-users/$appUserId/',
    path: '/app-users/$appUserId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute =
  AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRouteImport.update({
    id: '/app-user-helmets/$appUserHelmetId/',
    path: '/app-user-helmets/$appUserHelmetId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSellersSellerIdEditRoute =
  AuthenticatedSellersSellerIdEditRouteImport.update({
    id: '/sellers/$sellerId/edit',
    path: '/sellers/$sellerId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNewsNewsIdEditRoute =
  AuthenticatedNewsNewsIdEditRouteImport.update({
    id: '/news/$newsId/edit',
    path: '/news/$newsId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHelmetsHelmetIdEditRoute =
  AuthenticatedHelmetsHelmetIdEditRouteImport.update({
    id: '/helmets/$helmetId/edit',
    path: '/helmets/$helmetId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArticlesArticleIdEditRoute =
  AuthenticatedArticlesArticleIdEditRouteImport.update({
    id: '/articles/$articleId/edit',
    path: '/articles/$articleId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUsersAppUserIdEditRoute =
  AuthenticatedAppUsersAppUserIdEditRouteImport.update({
    id: '/app-users/$appUserId/edit',
    path: '/app-users/$appUserId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute =
  AuthenticatedAppUserHelmetsAppUserHelmetIdEditRouteImport.update({
    id: '/app-user-helmets/$appUserHelmetId/edit',
    path: '/app-user-helmets/$appUserHelmetId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/email-verification': typeof authEmailVerificationRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/new-password': typeof authNewPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/debug-sentry': typeof AuthenticatedDebugSentryRoute
  '/app/$': typeof AppSplatRoute
  '/profile/$healthProfileId': typeof ProfileHealthProfileIdRoute
  '/app-user-helmets/new': typeof AuthenticatedAppUserHelmetsNewRoute
  '/articles/new': typeof AuthenticatedArticlesNewRoute
  '/helmets/new': typeof AuthenticatedHelmetsNewRoute
  '/news/new': typeof AuthenticatedNewsNewRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/sellers/new': typeof AuthenticatedSellersNewRoute
  '/app-user-helmets/': typeof AuthenticatedAppUserHelmetsIndexRoute
  '/app-users/': typeof AuthenticatedAppUsersIndexRoute
  '/articles/': typeof AuthenticatedArticlesIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/helmets/': typeof AuthenticatedHelmetsIndexRoute
  '/news/': typeof AuthenticatedNewsIndexRoute
  '/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/sellers/': typeof AuthenticatedSellersIndexRoute
  '/app-user-helmets/$appUserHelmetId/edit': typeof AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute
  '/app-users/$appUserId/edit': typeof AuthenticatedAppUsersAppUserIdEditRoute
  '/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditRoute
  '/helmets/$helmetId/edit': typeof AuthenticatedHelmetsHelmetIdEditRoute
  '/news/$newsId/edit': typeof AuthenticatedNewsNewsIdEditRoute
  '/sellers/$sellerId/edit': typeof AuthenticatedSellersSellerIdEditRoute
  '/app-user-helmets/$appUserHelmetId/': typeof AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute
  '/app-users/$appUserId/': typeof AuthenticatedAppUsersAppUserIdIndexRoute
  '/articles/$articleId/': typeof AuthenticatedArticlesArticleIdIndexRoute
  '/helmets/$helmetId/': typeof AuthenticatedHelmetsHelmetIdIndexRoute
  '/news/$newsId/': typeof AuthenticatedNewsNewsIdIndexRoute
  '/sellers/$sellerId/': typeof AuthenticatedSellersSellerIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/email-verification': typeof authEmailVerificationRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/new-password': typeof authNewPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/debug-sentry': typeof AuthenticatedDebugSentryRoute
  '/app/$': typeof AppSplatRoute
  '/profile/$healthProfileId': typeof ProfileHealthProfileIdRoute
  '/app-user-helmets/new': typeof AuthenticatedAppUserHelmetsNewRoute
  '/articles/new': typeof AuthenticatedArticlesNewRoute
  '/helmets/new': typeof AuthenticatedHelmetsNewRoute
  '/news/new': typeof AuthenticatedNewsNewRoute
  '/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/sellers/new': typeof AuthenticatedSellersNewRoute
  '/app-user-helmets': typeof AuthenticatedAppUserHelmetsIndexRoute
  '/app-users': typeof AuthenticatedAppUsersIndexRoute
  '/articles': typeof AuthenticatedArticlesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/helmets': typeof AuthenticatedHelmetsIndexRoute
  '/news': typeof AuthenticatedNewsIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/sellers': typeof AuthenticatedSellersIndexRoute
  '/app-user-helmets/$appUserHelmetId/edit': typeof AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute
  '/app-users/$appUserId/edit': typeof AuthenticatedAppUsersAppUserIdEditRoute
  '/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditRoute
  '/helmets/$helmetId/edit': typeof AuthenticatedHelmetsHelmetIdEditRoute
  '/news/$newsId/edit': typeof AuthenticatedNewsNewsIdEditRoute
  '/sellers/$sellerId/edit': typeof AuthenticatedSellersSellerIdEditRoute
  '/app-user-helmets/$appUserHelmetId': typeof AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute
  '/app-users/$appUserId': typeof AuthenticatedAppUsersAppUserIdIndexRoute
  '/articles/$articleId': typeof AuthenticatedArticlesArticleIdIndexRoute
  '/helmets/$helmetId': typeof AuthenticatedHelmetsHelmetIdIndexRoute
  '/news/$newsId': typeof AuthenticatedNewsNewsIdIndexRoute
  '/sellers/$sellerId': typeof AuthenticatedSellersSellerIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/(auth)/email-verification': typeof authEmailVerificationRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/new-password': typeof authNewPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/_authenticated/debug-sentry': typeof AuthenticatedDebugSentryRoute
  '/app/$': typeof AppSplatRoute
  '/profile/$healthProfileId': typeof ProfileHealthProfileIdRoute
  '/_authenticated/app-user-helmets/new': typeof AuthenticatedAppUserHelmetsNewRoute
  '/_authenticated/articles/new': typeof AuthenticatedArticlesNewRoute
  '/_authenticated/helmets/new': typeof AuthenticatedHelmetsNewRoute
  '/_authenticated/news/new': typeof AuthenticatedNewsNewRoute
  '/_authenticated/notifications/new': typeof AuthenticatedNotificationsNewRoute
  '/_authenticated/sellers/new': typeof AuthenticatedSellersNewRoute
  '/_authenticated/app-user-helmets/': typeof AuthenticatedAppUserHelmetsIndexRoute
  '/_authenticated/app-users/': typeof AuthenticatedAppUsersIndexRoute
  '/_authenticated/articles/': typeof AuthenticatedArticlesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/helmets/': typeof AuthenticatedHelmetsIndexRoute
  '/_authenticated/news/': typeof AuthenticatedNewsIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/sellers/': typeof AuthenticatedSellersIndexRoute
  '/_authenticated/app-user-helmets/$appUserHelmetId/edit': typeof AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute
  '/_authenticated/app-users/$appUserId/edit': typeof AuthenticatedAppUsersAppUserIdEditRoute
  '/_authenticated/articles/$articleId/edit': typeof AuthenticatedArticlesArticleIdEditRoute
  '/_authenticated/helmets/$helmetId/edit': typeof AuthenticatedHelmetsHelmetIdEditRoute
  '/_authenticated/news/$newsId/edit': typeof AuthenticatedNewsNewsIdEditRoute
  '/_authenticated/sellers/$sellerId/edit': typeof AuthenticatedSellersSellerIdEditRoute
  '/_authenticated/app-user-helmets/$appUserHelmetId/': typeof AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute
  '/_authenticated/app-users/$appUserId/': typeof AuthenticatedAppUsersAppUserIdIndexRoute
  '/_authenticated/articles/$articleId/': typeof AuthenticatedArticlesArticleIdIndexRoute
  '/_authenticated/helmets/$helmetId/': typeof AuthenticatedHelmetsHelmetIdIndexRoute
  '/_authenticated/news/$newsId/': typeof AuthenticatedNewsNewsIdIndexRoute
  '/_authenticated/sellers/$sellerId/': typeof AuthenticatedSellersSellerIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/email-verification'
    | '/forgot-password'
    | '/new-password'
    | '/sign-in'
    | '/debug-sentry'
    | '/app/$'
    | '/profile/$healthProfileId'
    | '/app-user-helmets/new'
    | '/articles/new'
    | '/helmets/new'
    | '/news/new'
    | '/notifications/new'
    | '/sellers/new'
    | '/app-user-helmets/'
    | '/app-users/'
    | '/articles/'
    | '/dashboard/'
    | '/helmets/'
    | '/news/'
    | '/notifications/'
    | '/sellers/'
    | '/app-user-helmets/$appUserHelmetId/edit'
    | '/app-users/$appUserId/edit'
    | '/articles/$articleId/edit'
    | '/helmets/$helmetId/edit'
    | '/news/$newsId/edit'
    | '/sellers/$sellerId/edit'
    | '/app-user-helmets/$appUserHelmetId/'
    | '/app-users/$appUserId/'
    | '/articles/$articleId/'
    | '/helmets/$helmetId/'
    | '/news/$newsId/'
    | '/sellers/$sellerId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/email-verification'
    | '/forgot-password'
    | '/new-password'
    | '/sign-in'
    | '/debug-sentry'
    | '/app/$'
    | '/profile/$healthProfileId'
    | '/app-user-helmets/new'
    | '/articles/new'
    | '/helmets/new'
    | '/news/new'
    | '/notifications/new'
    | '/sellers/new'
    | '/app-user-helmets'
    | '/app-users'
    | '/articles'
    | '/dashboard'
    | '/helmets'
    | '/news'
    | '/notifications'
    | '/sellers'
    | '/app-user-helmets/$appUserHelmetId/edit'
    | '/app-users/$appUserId/edit'
    | '/articles/$articleId/edit'
    | '/helmets/$helmetId/edit'
    | '/news/$newsId/edit'
    | '/sellers/$sellerId/edit'
    | '/app-user-helmets/$appUserHelmetId'
    | '/app-users/$appUserId'
    | '/articles/$articleId'
    | '/helmets/$helmetId'
    | '/news/$newsId'
    | '/sellers/$sellerId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/(auth)/email-verification'
    | '/(auth)/forgot-password'
    | '/(auth)/new-password'
    | '/(auth)/sign-in'
    | '/_authenticated/debug-sentry'
    | '/app/$'
    | '/profile/$healthProfileId'
    | '/_authenticated/app-user-helmets/new'
    | '/_authenticated/articles/new'
    | '/_authenticated/helmets/new'
    | '/_authenticated/news/new'
    | '/_authenticated/notifications/new'
    | '/_authenticated/sellers/new'
    | '/_authenticated/app-user-helmets/'
    | '/_authenticated/app-users/'
    | '/_authenticated/articles/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/helmets/'
    | '/_authenticated/news/'
    | '/_authenticated/notifications/'
    | '/_authenticated/sellers/'
    | '/_authenticated/app-user-helmets/$appUserHelmetId/edit'
    | '/_authenticated/app-users/$appUserId/edit'
    | '/_authenticated/articles/$articleId/edit'
    | '/_authenticated/helmets/$helmetId/edit'
    | '/_authenticated/news/$newsId/edit'
    | '/_authenticated/sellers/$sellerId/edit'
    | '/_authenticated/app-user-helmets/$appUserHelmetId/'
    | '/_authenticated/app-users/$appUserId/'
    | '/_authenticated/articles/$articleId/'
    | '/_authenticated/helmets/$helmetId/'
    | '/_authenticated/news/$newsId/'
    | '/_authenticated/sellers/$sellerId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  authEmailVerificationRoute: typeof authEmailVerificationRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authNewPasswordRoute: typeof authNewPasswordRoute
  authSignInRoute: typeof authSignInRoute
  AppSplatRoute: typeof AppSplatRoute
  ProfileHealthProfileIdRoute: typeof ProfileHealthProfileIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$healthProfileId': {
      id: '/profile/$healthProfileId'
      path: '/profile/$healthProfileId'
      fullPath: '/profile/$healthProfileId'
      preLoaderRoute: typeof ProfileHealthProfileIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/$': {
      id: '/app/$'
      path: '/app/$'
      fullPath: '/app/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/debug-sentry': {
      id: '/_authenticated/debug-sentry'
      path: '/debug-sentry'
      fullPath: '/debug-sentry'
      preLoaderRoute: typeof AuthenticatedDebugSentryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/new-password': {
      id: '/(auth)/new-password'
      path: '/new-password'
      fullPath: '/new-password'
      preLoaderRoute: typeof authNewPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/email-verification': {
      id: '/(auth)/email-verification'
      path: '/email-verification'
      fullPath: '/email-verification'
      preLoaderRoute: typeof authEmailVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/sellers/': {
      id: '/_authenticated/sellers/'
      path: '/sellers'
      fullPath: '/sellers/'
      preLoaderRoute: typeof AuthenticatedSellersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/news/': {
      id: '/_authenticated/news/'
      path: '/news'
      fullPath: '/news/'
      preLoaderRoute: typeof AuthenticatedNewsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/helmets/': {
      id: '/_authenticated/helmets/'
      path: '/helmets'
      fullPath: '/helmets/'
      preLoaderRoute: typeof AuthenticatedHelmetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/articles/': {
      id: '/_authenticated/articles/'
      path: '/articles'
      fullPath: '/articles/'
      preLoaderRoute: typeof AuthenticatedArticlesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-users/': {
      id: '/_authenticated/app-users/'
      path: '/app-users'
      fullPath: '/app-users/'
      preLoaderRoute: typeof AuthenticatedAppUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-user-helmets/': {
      id: '/_authenticated/app-user-helmets/'
      path: '/app-user-helmets'
      fullPath: '/app-user-helmets/'
      preLoaderRoute: typeof AuthenticatedAppUserHelmetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sellers/new': {
      id: '/_authenticated/sellers/new'
      path: '/sellers/new'
      fullPath: '/sellers/new'
      preLoaderRoute: typeof AuthenticatedSellersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/new': {
      id: '/_authenticated/notifications/new'
      path: '/notifications/new'
      fullPath: '/notifications/new'
      preLoaderRoute: typeof AuthenticatedNotificationsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/news/new': {
      id: '/_authenticated/news/new'
      path: '/news/new'
      fullPath: '/news/new'
      preLoaderRoute: typeof AuthenticatedNewsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/helmets/new': {
      id: '/_authenticated/helmets/new'
      path: '/helmets/new'
      fullPath: '/helmets/new'
      preLoaderRoute: typeof AuthenticatedHelmetsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/articles/new': {
      id: '/_authenticated/articles/new'
      path: '/articles/new'
      fullPath: '/articles/new'
      preLoaderRoute: typeof AuthenticatedArticlesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-user-helmets/new': {
      id: '/_authenticated/app-user-helmets/new'
      path: '/app-user-helmets/new'
      fullPath: '/app-user-helmets/new'
      preLoaderRoute: typeof AuthenticatedAppUserHelmetsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sellers/$sellerId/': {
      id: '/_authenticated/sellers/$sellerId/'
      path: '/sellers/$sellerId'
      fullPath: '/sellers/$sellerId/'
      preLoaderRoute: typeof AuthenticatedSellersSellerIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/news/$newsId/': {
      id: '/_authenticated/news/$newsId/'
      path: '/news/$newsId'
      fullPath: '/news/$newsId/'
      preLoaderRoute: typeof AuthenticatedNewsNewsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/helmets/$helmetId/': {
      id: '/_authenticated/helmets/$helmetId/'
      path: '/helmets/$helmetId'
      fullPath: '/helmets/$helmetId/'
      preLoaderRoute: typeof AuthenticatedHelmetsHelmetIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/articles/$articleId/': {
      id: '/_authenticated/articles/$articleId/'
      path: '/articles/$articleId'
      fullPath: '/articles/$articleId/'
      preLoaderRoute: typeof AuthenticatedArticlesArticleIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-users/$appUserId/': {
      id: '/_authenticated/app-users/$appUserId/'
      path: '/app-users/$appUserId'
      fullPath: '/app-users/$appUserId/'
      preLoaderRoute: typeof AuthenticatedAppUsersAppUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-user-helmets/$appUserHelmetId/': {
      id: '/_authenticated/app-user-helmets/$appUserHelmetId/'
      path: '/app-user-helmets/$appUserHelmetId'
      fullPath: '/app-user-helmets/$appUserHelmetId/'
      preLoaderRoute: typeof AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sellers/$sellerId/edit': {
      id: '/_authenticated/sellers/$sellerId/edit'
      path: '/sellers/$sellerId/edit'
      fullPath: '/sellers/$sellerId/edit'
      preLoaderRoute: typeof AuthenticatedSellersSellerIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/news/$newsId/edit': {
      id: '/_authenticated/news/$newsId/edit'
      path: '/news/$newsId/edit'
      fullPath: '/news/$newsId/edit'
      preLoaderRoute: typeof AuthenticatedNewsNewsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/helmets/$helmetId/edit': {
      id: '/_authenticated/helmets/$helmetId/edit'
      path: '/helmets/$helmetId/edit'
      fullPath: '/helmets/$helmetId/edit'
      preLoaderRoute: typeof AuthenticatedHelmetsHelmetIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/articles/$articleId/edit': {
      id: '/_authenticated/articles/$articleId/edit'
      path: '/articles/$articleId/edit'
      fullPath: '/articles/$articleId/edit'
      preLoaderRoute: typeof AuthenticatedArticlesArticleIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-users/$appUserId/edit': {
      id: '/_authenticated/app-users/$appUserId/edit'
      path: '/app-users/$appUserId/edit'
      fullPath: '/app-users/$appUserId/edit'
      preLoaderRoute: typeof AuthenticatedAppUsersAppUserIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app-user-helmets/$appUserHelmetId/edit': {
      id: '/_authenticated/app-user-helmets/$appUserHelmetId/edit'
      path: '/app-user-helmets/$appUserHelmetId/edit'
      fullPath: '/app-user-helmets/$appUserHelmetId/edit'
      preLoaderRoute: typeof AuthenticatedAppUserHelmetsAppUserHelmetIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDebugSentryRoute: typeof AuthenticatedDebugSentryRoute
  AuthenticatedAppUserHelmetsNewRoute: typeof AuthenticatedAppUserHelmetsNewRoute
  AuthenticatedArticlesNewRoute: typeof AuthenticatedArticlesNewRoute
  AuthenticatedHelmetsNewRoute: typeof AuthenticatedHelmetsNewRoute
  AuthenticatedNewsNewRoute: typeof AuthenticatedNewsNewRoute
  AuthenticatedNotificationsNewRoute: typeof AuthenticatedNotificationsNewRoute
  AuthenticatedSellersNewRoute: typeof AuthenticatedSellersNewRoute
  AuthenticatedAppUserHelmetsIndexRoute: typeof AuthenticatedAppUserHelmetsIndexRoute
  AuthenticatedAppUsersIndexRoute: typeof AuthenticatedAppUsersIndexRoute
  AuthenticatedArticlesIndexRoute: typeof AuthenticatedArticlesIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedHelmetsIndexRoute: typeof AuthenticatedHelmetsIndexRoute
  AuthenticatedNewsIndexRoute: typeof AuthenticatedNewsIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedSellersIndexRoute: typeof AuthenticatedSellersIndexRoute
  AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute: typeof AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute
  AuthenticatedAppUsersAppUserIdEditRoute: typeof AuthenticatedAppUsersAppUserIdEditRoute
  AuthenticatedArticlesArticleIdEditRoute: typeof AuthenticatedArticlesArticleIdEditRoute
  AuthenticatedHelmetsHelmetIdEditRoute: typeof AuthenticatedHelmetsHelmetIdEditRoute
  AuthenticatedNewsNewsIdEditRoute: typeof AuthenticatedNewsNewsIdEditRoute
  AuthenticatedSellersSellerIdEditRoute: typeof AuthenticatedSellersSellerIdEditRoute
  AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute: typeof AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute
  AuthenticatedAppUsersAppUserIdIndexRoute: typeof AuthenticatedAppUsersAppUserIdIndexRoute
  AuthenticatedArticlesArticleIdIndexRoute: typeof AuthenticatedArticlesArticleIdIndexRoute
  AuthenticatedHelmetsHelmetIdIndexRoute: typeof AuthenticatedHelmetsHelmetIdIndexRoute
  AuthenticatedNewsNewsIdIndexRoute: typeof AuthenticatedNewsNewsIdIndexRoute
  AuthenticatedSellersSellerIdIndexRoute: typeof AuthenticatedSellersSellerIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDebugSentryRoute: AuthenticatedDebugSentryRoute,
  AuthenticatedAppUserHelmetsNewRoute: AuthenticatedAppUserHelmetsNewRoute,
  AuthenticatedArticlesNewRoute: AuthenticatedArticlesNewRoute,
  AuthenticatedHelmetsNewRoute: AuthenticatedHelmetsNewRoute,
  AuthenticatedNewsNewRoute: AuthenticatedNewsNewRoute,
  AuthenticatedNotificationsNewRoute: AuthenticatedNotificationsNewRoute,
  AuthenticatedSellersNewRoute: AuthenticatedSellersNewRoute,
  AuthenticatedAppUserHelmetsIndexRoute: AuthenticatedAppUserHelmetsIndexRoute,
  AuthenticatedAppUsersIndexRoute: AuthenticatedAppUsersIndexRoute,
  AuthenticatedArticlesIndexRoute: AuthenticatedArticlesIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedHelmetsIndexRoute: AuthenticatedHelmetsIndexRoute,
  AuthenticatedNewsIndexRoute: AuthenticatedNewsIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedSellersIndexRoute: AuthenticatedSellersIndexRoute,
  AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute:
    AuthenticatedAppUserHelmetsAppUserHelmetIdEditRoute,
  AuthenticatedAppUsersAppUserIdEditRoute:
    AuthenticatedAppUsersAppUserIdEditRoute,
  AuthenticatedArticlesArticleIdEditRoute:
    AuthenticatedArticlesArticleIdEditRoute,
  AuthenticatedHelmetsHelmetIdEditRoute: AuthenticatedHelmetsHelmetIdEditRoute,
  AuthenticatedNewsNewsIdEditRoute: AuthenticatedNewsNewsIdEditRoute,
  AuthenticatedSellersSellerIdEditRoute: AuthenticatedSellersSellerIdEditRoute,
  AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute:
    AuthenticatedAppUserHelmetsAppUserHelmetIdIndexRoute,
  AuthenticatedAppUsersAppUserIdIndexRoute:
    AuthenticatedAppUsersAppUserIdIndexRoute,
  AuthenticatedArticlesArticleIdIndexRoute:
    AuthenticatedArticlesArticleIdIndexRoute,
  AuthenticatedHelmetsHelmetIdIndexRoute:
    AuthenticatedHelmetsHelmetIdIndexRoute,
  AuthenticatedNewsNewsIdIndexRoute: AuthenticatedNewsNewsIdIndexRoute,
  AuthenticatedSellersSellerIdIndexRoute:
    AuthenticatedSellersSellerIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  authEmailVerificationRoute: authEmailVerificationRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authNewPasswordRoute: authNewPasswordRoute,
  authSignInRoute: authSignInRoute,
  AppSplatRoute: AppSplatRoute,
  ProfileHealthProfileIdRoute: ProfileHealthProfileIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
